export default __webpack_public_path__ + "081c91161921be2e21f6f959629cd22f.png";